import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import dayjs, { Dayjs } from 'dayjs';
import { Observable } from 'rxjs';
import { DailyScanTimesDashboardConfiguration } from './daily-scan-times-dashboard-configuration';
import { ResultFieldFilter } from '../job-result-analytics-dashboard/job-result-analytics-dashboard-configuration';
import { JobDashboardRange } from '../job-dashboard/job-dashboard-configuration';
import { environment } from '../../../../../environments/environment';
import {
  getFromForRange,
  getToForRange,
} from '../job-dashboard/job-dashboard-range.utils';

export interface DayScanTimes {
  date: string;
  firstScan: string | null;
  lastScan: string | null;
  scanCount: number;
}

export interface JobResultDailyScanTimesResponse {
  days: DayScanTimes[];
  warnings: string[];
}

interface JobResultDailyScanTimesRequest {
  dataConnectionIds?: string[];
  statuses?: string[];
  from: Dayjs;
  to: Dayjs;
  timezone: string;
  scanTimestampFieldKey: string;
  filters?: ResultFieldFilter[];
}

@Injectable({
  providedIn: 'root',
})
export class DailyScanTimesDashboardService {
  protected http = inject(HttpClient);

  getData(
    config: DailyScanTimesDashboardConfiguration,
    from: Dayjs,
    to: Dayjs,
    scanTimestampFieldKey: string,
  ): Observable<JobResultDailyScanTimesResponse> {
    const requestBody: JobResultDailyScanTimesRequest = {
      dataConnectionIds: config.dataConnectionIds,
      statuses: config.statuses,
      from,
      to,
      timezone: this.getBrowserTimezone(),
      scanTimestampFieldKey,
      filters: config.filters,
    };

    return this.http.post<JobResultDailyScanTimesResponse>(
      `${environment.apiUrls.workflow}/api/v1/dashboard/jobs/results/daily-scan-times`,
      requestBody,
    );
  }

  getFromForRange(range: JobDashboardRange, referenceTime = dayjs()): Dayjs {
    return getFromForRange(range, referenceTime);
  }

  getToForRange(range: JobDashboardRange, referenceTime = dayjs()): Dayjs {
    return getToForRange(range, referenceTime);
  }

  getBrowserTimezone(): string {
    try {
      return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
    } catch {
      return 'UTC';
    }
  }
}
